import { useScreenState } from '@gogame/screens';

import { useChartIndex } from './useChartIndex';

export const useChartState = (temporary) => {
  const chartIndex = useChartIndex();
  let screenState = useScreenState();

  if (temporary && screenState.temporary) {
    screenState = screenState.temporary;
  }
  return screenState.charts[chartIndex];
};
